import antMessage from '../../../utils/extend/AntdNotification';
import React, { useEffect, useRef, useState } from 'react'
import AntDraggableModal from '../../../utils/extend/AntDraggableModal'
import { Button, Card, Col, Form, InputNumber, List, Row } from 'antd';
import fetchApi from '../../../utils/api/fetchApi';
import systemConfig from '../../../config/systematic';
import idHandle from '../../../utilsTs/baseLib/idHandle';


export default function MountCheckout(props: any) {
    const { data, closeModal } = props;
    const [loading, setLoading] = useState<boolean>(false);
    const [form] = Form.useForm(); //form 
    const [isCurrentPaymentData, setIsCurrentPaymentData] = useState<any>();
    /** 后端数据wmService */
    let wmService: any = systemConfig.wmService;
    const [initPaymentLlists, setInitPaymentLlists] = useState<Array<any>>([]);
    const [seletePaymentData, setSeletePaymentData] = useState<any>([]);
    const [isPayDetailsOpen, setIsPayDetailsOpen] = useState<boolean>(false);
    const [isCurrentPrice, setIsCurrentPrice] = useState<any>(0);
    const [deletePaymentListIds, setDeletePaymentListIds] = useState<Array<any>>([]);
    const [deletePaymentIds, setDeletePaymentIds] = useState<Array<any>>([]);

    const handleCancel = (e: any) => {
        closeModal(false)

    }
    const handleOk = (e: any) => {

        setLoading(true)
        form.validateFields() //数据校验
            .then(async (values: any) => {

                fetchApi.POST(wmService, {
                    apiId: "cateringOrder",
                    apiExtend: "mountCheckout",
                    apiData: {
                        id: data.id,
                        paymentMethodList: seletePaymentData,
                        deletePaymentListIds,
                        deletePaymentIds
                    }
                }).then(res => {
                    antMessage('success', '挂载成功', 'success', { duration: 0.5 });

                    setLoading(false)
                    closeModal(false)
                }).catch(err => {
                    antMessage("error", '挂载失败', JSON.stringify(err), { duration: 0.5 });
                    setLoading(false)

                })
            })
            .catch((err: any) => {
                antMessage("error", '失败', JSON.stringify(err), { duration: 0.5 });
                setLoading(false)

            });


    }
    //初始化数据
    const initData = (apiData?: any) => {

        fetchApi.GET(wmService, {
            apiId: "payDetails",
            apiExtend: "showList",
            apiData: {
                cateringOrderId: data.id
            }

        }).then((res) => {

            setSeletePaymentData(res.data)
        })
    }
    useEffect(() => {
        initData()

        const fetchData = async () => {
            fetchApi.GET(wmService,
                {
                    apiId: 'paymentList',
                    apiExtend: 'showList',
                    apiData: {
                        // isPayCode: true,
                        // isOnlinePayment: true,
                        mountDataOptions: {
                            userMount: {
                                isDept: true,
                            }
                        },

                    }
                }).then(res => {
                    if (res.success) {

                        if (res.data.length > 1) {
                            setInitPaymentLlists(res.data)
                        }

                    }
                });
        }

        fetchData()



    }, [])
    /**选择支付方式 */
    const payDetailsChage = (e: any) => {
        let id = idHandle.getShortUuid()
        let selectData = [{ copies: 1, ...e, money: isCurrentPrice, status: 2, id, paymentMethodListId: e.id }]

        let lastSelectData = seletePaymentData.concat(selectData);
        setSeletePaymentData(lastSelectData)
        setIsPayDetailsOpen(false)
    }
    /** 修改金额*/
    const changePrice = (e: any) => {


        setIsCurrentPrice(e)
    }
    const payDetailCon = () => {

        switch (isCurrentPaymentData.paymentType) {
            case 1:
            case 5:
            case 6:
                return <InputNumber min={0.1} controls={false} onChange={(e) => changePrice(e)} addonBefore={<div>金额:</div>}></InputNumber>
            case 2:
                return <div style={{ justifyContent: "space-between", display: "flex", fontSize: 16 }}><InputNumber min={0.1} style={{ width: "50%" }} readOnly value={isCurrentPrice} onChange={(e) => changePrice(e)} addonBefore={<div>金额:</div>}></InputNumber> <InputNumber defaultValue={1} min={1} onChange={(e) => numberCopies(e, isCurrentPaymentData)} style={{ width: "50%" }} addonBefore={<>张数:</>} /></div>
            case 4:
                return <div style={{ justifyContent: "space-between", display: "flex", fontSize: 16 }}><InputNumber min={0.1} style={{ width: "50%" }} value={isCurrentPrice} onChange={(e) => changePrice(e)} addonBefore={<div>金额:</div>}></InputNumber></div>
            default:
                return <></>
        }
    }

    const numberCopies = (e: any, isCurrentPaymentData: any) => {
        setIsCurrentPaymentData({ ...isCurrentPaymentData, copies: e })
        let price = e * isCurrentPaymentData.deductionAmount;
        changePrice(price)

    }
    return (
        <>
            <AntDraggableModal
                title={<div>挂载结账</div>}
                open={true}
                okText='确定'
                cancelText='取消'
                onOk={handleOk}
                onCancel={handleCancel}
                closable={false}
                maskClosable={false}
                width={"80%"}
                confirmLoading={loading}
            >
                {/* <Row> */}
                {/* <Col span={10}> */}
                <div >
                    <Form
                        form={form}
                        name="Edit"
                        onFinish={handleOk}

                        initialValues={{
                            showDiscount: true,
                            showPerCapita: true,
                            showPeople: true,
                            showName: true,
                            printType: "cateringCheckoutDetailAccountsOrder",

                        }}
                        onKeyDown={(e: any) => {
                            if (e.key === 'Enter') {
                                handleOk(e)
                            }
                        }}
                    >
                        <Row>
                            <Col span={10}>
                                {
                                    seletePaymentData?.length > 0 ? <Col span={24}>
                                        <List
                                            size="small"
                                            dataSource={seletePaymentData}
                                            renderItem={(item: any) => <List.Item>
                                                <div style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
                                                    <div>{item.paymentMethodName}</div>
                                                    <div>￥{item.money.toFixed(2)}</div>
                                                    <div onClick={() => {
                                                        if (item.status === 1) {
                                                            let newArray: Array<string> = [...deletePaymentListIds, item.id];
                                                            let newArrayEx: Array<string> = [...deletePaymentIds, item.paymentMethodId];
                                                            setDeletePaymentIds(newArrayEx)
                                                            setDeletePaymentListIds(newArray)
                                                        }
                                                        setSeletePaymentData((prevData: any) => prevData.filter((item1: any) => item1.id !== item.id))
                                                        // form.setFieldValue("realMoney", (realMoney ? Number(realMoney) : 0) - Number(item.money))
                                                    }}>撤销</div>

                                                </div></List.Item>}
                                        />



                                    </Col> : null

                                }
                            </Col>
                            <Col span={11}>
                                {initPaymentLlists.length > 0 ?
                                    <div
                                        id="scrollableDiv"
                                        style={{
                                            height: 500,
                                            overflow: 'auto',
                                            padding: '0 16px',
                                            marginTop: 20,
                                            border: '1px solid rgba(140, 140, 140, 0.35)',
                                        }}
                                    >
                                        <List
                                            itemLayout="horizontal"
                                            grid={{ gutter: 16, column: 3 }}

                                            dataSource={initPaymentLlists}
                                            // position
                                            renderItem={(menu: any) => {
                                                return (
                                                    <List.Item onClick={() => {
                                                        setIsCurrentPaymentData(menu)
                                                        if (menu.paymentMethodId === "wiscaMembershipCard") {
                                                            antMessage("error", `暂时不支持${menu.paymentMethodName}`);
                                                            return false
                                                        }

                                                        // if (seletePaymentData.length > 0) {
                                                        //     let findData = seletePaymentData.find((item: any) => item.id === menu.id);
                                                        //     if (findData) {
                                                        //         antMessage("error", "该结账方式已存在，无法重复加入");
                                                        //         return false
                                                        //     }

                                                        // }
                                                        if (menu.paymentType === 2) {

                                                            setIsCurrentPrice(menu.deductionAmount)
                                                        }

                                                        if (menu.paymentType === 4) {

                                                            setIsCurrentPrice(menu.deductionAmount)
                                                        }

                                                        setIsPayDetailsOpen(true)
                                                        // setIsCurrentPrice((shouldMoney ? Number(shouldMoney) : 0) - (realMoney ? Number(realMoney) : 0))
                                                    }}>
                                                        <Card
                                                            size='small'
                                                            title={
                                                                <>
                                                                    <div style={{ justifyContent: "space-between", display: "flex", fontSize: 16 }}>
                                                                        <div>{menu.paymentMethodName}</div>

                                                                    </div>
                                                                </>
                                                            }
                                                        >

                                                        </Card>
                                                    </List.Item>
                                                )
                                            }}
                                        />
                                    </div>
                                    : null}



                            </Col>

                        </Row>
                    </Form>



                </div>
                {/* </Col> */}


                {/* </Row> */}

            </AntDraggableModal>
            {isPayDetailsOpen ? <AntDraggableModal

                open={true}
                // okButtonProps={{ disabled: true }}
                // cancelButtonProps={{ disabled: true }}
                okText='确定'
                cancelText="取消"
                onCancel={() => { setIsPayDetailsOpen(false) }}
                onOk={() => { payDetailsChage(isCurrentPaymentData) }}
                title={`支付方式:${isCurrentPaymentData?.paymentMethodName}${isCurrentPaymentData.paymentType === 2 ? ` 抵扣金额:${isCurrentPaymentData.deductionAmount}元` : ""}`}
                width={800}>
                {payDetailCon()}
                {/* {isCurrentPaymentData.paymentType === 1 ? <InputNumber defaultValue={(shouldMoney ? Number(shouldMoney) : 0) - (realMoney ? Number(realMoney) : 0)} max={(shouldMoney ? Number(shouldMoney) : 0) - (realMoney ? Number(realMoney) : 0)} onChange={(e) => changePrice(e)} addonAfter={<Button onClick={(e) => payDetailsChage(isCurrentPaymentData)}>确认</Button>} addonBefore={<div>金额:</div>}></InputNumber> : null} */}
            </AntDraggableModal> : null}

        </>
    )
}
